import { FormikValues } from 'formik'

import { PositionCreateInput } from '../../../__generated__/graphql'
import prepareFormValues from '../../../utils/prepareFormValues'
import { fromPercentToFloat } from '../settings/Summary/SettingsSummary'

export const toPositionCreateInput = (formValues: FormikValues, websiteId: string | number): PositionCreateInput => {
  const cleanData = prepareFormValues(formValues) as PositionCreateInput & { revenueShare: number }

  return Object.assign({}, cleanData, {
    websiteId,
    revenueShare: fromPercentToFloat(cleanData.revenueShare),
  })
}
